import Vue from 'vue'
import router from '../../router'

export default {
  addNewPage ({ commit }, data) {
    commit('ADD_NEW_ADDITIONAL_PAGE', data)
    router.push({ name: 'AdditionalPage', params: { id: 'new' } })
  },
  getPages ({ commit }, id) {
    return Vue.axios.get('/additional-pages')
    .then(({ data }) => {
      commit('ADD_ADDITINAL_PAGES', data)
      if (data[0] && (!id || id === 'new')) {
        commit('ADD_ADDITINAL_PAGE', data[0])
        router.push(`/additional-pages/${data[0].id}`)
      } else {
        commit('ADD_ADDITINAL_PAGE', data.find(d => id === d.id))
      }
    })
  },
  getPage ({ commit }, id) {
    return Vue.axios.get(`/additional-pages/${id}`)
    .then(({ data }) => commit('ADD_ADDITINAL_PAGE', data))
  },
  updateAdditionalPage ({ commit }, page) {
    commit('UPDATE_ADDITIONAL_PAGE', page)
  },
  saveAdditionalPage ({ commit }, page) {
    return Vue.axios.put(`/additional-pages/${page.id}`, { page })
    .then(() => {
      commit('UPDATE_ADDITIONAL_PAGE', page)
    })
  },
  deleteAdditionalPage ({ commit, state }, id) {
    return Vue.axios.delete(`/additional-pages/${id}`)
    .then(() => {
      commit('DELETE_ADDITIONAL_PAGE', id)
      const firstPage = state.pages[0]
      commit('ADD_ADDITINAL_PAGE', firstPage)
      if (firstPage) {
        router.push(`/additional-pages/${firstPage.id}`)
      } else {
        router.push(`/additional-pages`)
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/actions/pages.js